import { Reducer } from 'redux';
import { Histories } from '../entities';
import { IFetchHistories, ISetHistories, ISetRemote, THistories, TRemote } from '../actions';

export type IHistoriesState = Histories[];
export const defaultHistoriesState = [];

export const historiesReducer: Reducer<IHistoriesState> =
  (state: IHistoriesState = defaultHistoriesState, action: ISetHistories | IFetchHistories | ISetRemote) => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
    case THistories.FETCH_HISTORIES:
      return defaultHistoriesState;
    case THistories.SET_HISTORIES:
      return action.payload;
  }
  return state;
};
